import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

export const readWorkflowStage: OpalApi<'ReadWorkflowStageV3', 200> = async ({
  params,
}: Parameters<OpalApi<'ReadWorkflowStageV3', 200>>[0] = {}) => {
  const url = new URL(
    `/v3/workflow_stages/${params?.path.workflow_stage_id}`,
    window.location.origin
  )
  url.search = queryString(params?.query)
  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
